(function () {
  'use strict';

  var DEFAULT_API_URL =
    'https://igthraqyjiadzclkkixn.supabase.co/functions/v1/city-collections';
  var CACHE_KEY = 'loven:city-collections:v2';
  var CACHE_TTL_MS = 5 * 60 * 1000;
  var FETCH_TIMEOUT_MS = 12000;
  var ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function letterFromTitle(title) {
    var t = String(title || '').trim();
    if (!t) return 'A';
    var ch = t.charAt(0).toUpperCase();
    var n = norm(ch).charAt(0).toUpperCase();
    if (n >= 'A' && n <= 'Z') return n;
    return 'A';
  }

  function readConfig(sectionId) {
    var el = document.getElementById('loven-villes-config-' + sectionId);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function readPickerData(sectionId) {
    var el = document.getElementById('loven-villes-data-' + sectionId);
    if (!el || !el.textContent) return [];
    try {
      var rows = JSON.parse(el.textContent.trim());
      return Array.isArray(rows) ? rows : [];
    } catch (e) {
      return [];
    }
  }

  function readCache() {
    try {
      if (!window.sessionStorage) return null;
      var raw = window.sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || !entry.at || Date.now() - entry.at > CACHE_TTL_MS) return null;
      return entry.data || null;
    } catch (e) {
      return null;
    }
  }

  function writeCache(data) {
    try {
      if (!window.sessionStorage) return;
      window.sessionStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ at: Date.now(), data: data })
      );
    } catch (e) {}
  }

  function normalizeRow(row, shopUrl) {
    if (!row || typeof row !== 'object') return null;
    var title = String(row.title || row.name || row.ville || row.city || '').trim();
    var handle = String(row.handle || '').trim().toLowerCase();
    if (!title && !handle) return null;
    if (!title) title = handle;
    var url = String(row.url || row.collection_url || '').trim();
    if (!url && handle) {
      url = (shopUrl || '').replace(/\/$/, '') + '/collections/' + handle;
    }
    return { title: title, handle: handle, url: url };
  }

  function extractCollections(payload, shopUrl) {
    if (!payload) return [];
    var raw = [];
    if (Array.isArray(payload)) {
      raw = payload;
    } else {
      raw =
        payload.collections ||
        payload.cities ||
        payload.villes ||
        (payload.data && (payload.data.collections || payload.data.cities)) ||
        [];
    }
    if (!Array.isArray(raw)) return [];
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var row = normalizeRow(raw[i], shopUrl);
      if (row) out.push(row);
    }
    out.sort(function (a, b) {
      return a.title.localeCompare(b.title, 'fr', { sensitivity: 'base' });
    });
    return out;
  }

  function fetchCityCollections(apiUrl) {
    var cached = readCache();
    if (cached && !cached.error && Array.isArray(cached.collections)) {
      return Promise.resolve({ collections: cached, source: 'cache' });
    }

    var controller = null;
    var timeoutTimer = null;
    try {
      if (typeof AbortController === 'function') {
        controller = new AbortController();
        timeoutTimer = setTimeout(function () {
          try {
            controller.abort();
          } catch (e) {}
        }, FETCH_TIMEOUT_MS);
      }
    } catch (e) {}

    var init = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    };
    if (controller) init.signal = controller.signal;

    return fetch(apiUrl || DEFAULT_API_URL, init)
      .then(function (r) {
        if (!r.ok) {
          return r.text().then(function (txt) {
            var err = new Error('city-collections http-' + r.status);
            err.detail = txt;
            throw err;
          });
        }
        return r.json();
      })
      .then(function (data) {
        if (timeoutTimer) clearTimeout(timeoutTimer);
        writeCache(data);
        return { collections: data, source: 'network' };
      })
      .catch(function (err) {
        if (timeoutTimer) clearTimeout(timeoutTimer);
        throw err;
      });
  }

  function buildListHtml(collections) {
    var byLetter = {};
    ALPHABET.forEach(function (L) {
      byLetter[L] = [];
    });

    collections.forEach(function (c) {
      var L = letterFromTitle(c.title);
      if (!byLetter[L]) byLetter[L] = [];
      byLetter[L].push(c);
    });

    var html = '';
    ALPHABET.forEach(function (L) {
      var rows = byLetter[L];
      if (!rows || !rows.length) return;
      html +=
        '<section id="loven-ville-letter-' +
        L +
        '" class="loven-villes__group" data-loven-ville-group data-letter="' +
        L +
        '">' +
        '<h2 class="loven-villes__letter-heading">' +
        L +
        '</h2><ul class="loven-villes__items">';
      rows.forEach(function (c) {
        html +=
          '<li class="loven-villes__item" data-loven-ville-item data-city-name="' +
          escapeHtml(c.title) +
          '">' +
          '<a href="' +
          escapeHtml(c.url) +
          '" class="loven-villes__link">' +
          escapeHtml(c.title) +
          '</a></li>';
      });
      html += '</ul></section>';
    });
    return html;
  }

  function buildAbcHtml() {
    return ALPHABET.map(function (L) {
      return (
        '<a href="#loven-ville-letter-' +
        L +
        '" class="loven-villes__abc-link" data-loven-abc-letter="' +
        L +
        '">' +
        L +
        '</a>'
      );
    }).join('');
  }

  function bindFilter(root, total) {
    var search = root.querySelector('[data-loven-villes-search]');
    var list = root.querySelector('[data-loven-villes-list]');
    var countWrap = root.querySelector('[data-loven-villes-meta]');
    var noResults = root.querySelector('[data-loven-villes-no-results]');
    var abc = root.querySelector('[data-loven-villes-abc]');
    if (!search || !list) return;

    var items = list.querySelectorAll('[data-loven-ville-item]');
    var groups = list.querySelectorAll('[data-loven-ville-group]');

    if (abc) {
      var lettersPresent = {};
      groups.forEach(function (g) {
        var L = g.getAttribute('data-letter');
        if (L) lettersPresent[L] = true;
      });
      abc.querySelectorAll('[data-loven-abc-letter]').forEach(function (link) {
        var letter = link.getAttribute('data-loven-abc-letter');
        if (!lettersPresent[letter]) {
          link.classList.add('is-disabled');
          link.setAttribute('aria-disabled', 'true');
          link.removeAttribute('href');
        }
      });
    }

    function applyFilter(query) {
      var q = norm(query);
      var visible = 0;
      items.forEach(function (item) {
        var name = norm(item.getAttribute('data-city-name') || item.textContent);
        var show = !q || name.indexOf(q) !== -1;
        item.hidden = !show;
        if (show) visible += 1;
      });
      groups.forEach(function (group) {
        var any = false;
        group.querySelectorAll('[data-loven-ville-item]').forEach(function (item) {
          if (!item.hidden) any = true;
        });
        group.hidden = !any;
      });
      if (countWrap) {
        countWrap.textContent = (q ? visible : total) + ' ' + (root.__cityCountLabel || '');
      }
      if (noResults) {
        noResults.hidden = visible > 0 || !q;
      }
    }

    search.addEventListener('input', function () {
      applyFilter(search.value);
    });
    applyFilter('');
  }

  function showReady(root, config, collections) {
    var labels = (config && config.labels) || {};
    var toolbar = root.querySelector('[data-loven-villes-toolbar]');
    var list = root.querySelector('[data-loven-villes-list]');
    var status = root.querySelector('[data-loven-villes-status]');
    var searchLabel = root.querySelector('[data-loven-villes-search-label]');
    var search = root.querySelector('[data-loven-villes-search]');
    var abc = root.querySelector('[data-loven-villes-abc]');
    var noResults = root.querySelector('[data-loven-villes-no-results]');

    root.__cityCountLabel = labels.cityCount || 'villes';

    if (searchLabel) searchLabel.textContent = labels.searchLabel || '';
    if (search) search.placeholder = labels.searchPlaceholder || '';
    if (abc) {
      abc.setAttribute('aria-label', labels.abcNav || '');
      abc.innerHTML = buildAbcHtml();
    }
    if (noResults) noResults.textContent = labels.searchEmpty || '';

    if (!collections.length) {
      root.classList.remove('loven-villes--loading');
      if (status) status.textContent = labels.empty || '';
      return;
    }

    if (list) {
      list.innerHTML = buildListHtml(collections);
      list.hidden = false;
    }
    if (toolbar) toolbar.hidden = false;
    if (status) status.textContent = '';
    root.classList.remove('loven-villes--loading');

    bindFilter(root, collections.length);
  }

  function parseFetchError(err) {
    var msg = (err && err.message) || '';
    if (!err || !err.detail) return msg;
    try {
      var body = JSON.parse(err.detail);
      if (body.error === 'shopify_graphql_error') {
        console.error('[Loven villes] city-collections — erreur GraphQL Shopify', body.details || body);
        return 'Erreur catalogue Shopify (GraphQL). Corrigez la requête dans Lovable (city-collections).';
      }
      if (body.error) return String(body.error);
    } catch (e) {
      return msg;
    }
    return msg;
  }

  function showError(root, config, message) {
    var labels = (config && config.labels) || {};
    var status = root.querySelector('[data-loven-villes-status]');
    root.classList.remove('loven-villes--loading');
    if (status) {
      status.textContent = (labels.loadError || 'Erreur de chargement.') + ' ' + (message || '');
    }
  }

  function showLoading(root, config) {
    var labels = (config && config.labels) || {};
    var status = root.querySelector('[data-loven-villes-status]');
    root.classList.add('loven-villes--loading');
    if (status) status.textContent = labels.loading || '';
  }

  function initRoot(root) {
    var sectionId = root.getAttribute('data-loven-section-id');
    if (!sectionId) return;
    var config = readConfig(sectionId);
    if (!config) return;

    showLoading(root, config);

    var source = config.source || root.getAttribute('data-loven-villes-source') || 'api';
    var shopUrl = config.shopUrl || '';

    if (source === 'picker') {
      var pickerRows = readPickerData(sectionId).map(function (r) {
        return normalizeRow(r, shopUrl);
      }).filter(Boolean);
      showReady(root, config, pickerRows);
      return;
    }

    var apiUrl = config.apiUrl || DEFAULT_API_URL;
    fetchCityCollections(apiUrl)
      .then(function (res) {
        var payload = res.collections;
        var rows = extractCollections(payload, shopUrl);
        showReady(root, config, rows);
      })
      .catch(function (err) {
        showError(root, config, parseFetchError(err));
      });
  }

  function boot() {
    document.querySelectorAll('[data-loven-villes-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
